/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const metaAdCampaignDataStatusSchema = z.enum(['new', 'draft', 'queued', 'pushed', 'ended', 'error'])

export type MetaAdCampaignDataStatusSchema = z.infer<typeof metaAdCampaignDataStatusSchema>
